import { useState } from "react";
import Axios from '../../axios/axios';

const ReviewModal = ({ isOpen, onClose, id, userInfo,setReviews}) => {
    const [rating, setRating] = useState(0);
    const [note, setNote] = useState("");

    const handleReview = async () => { 
    const data = {
        partsId: id,
        rating: Number(rating), // Convert rating to number
        note,
        customerId: userInfo.customerId
    };

    try {
        const res = await Axios.post(`/review/create`, data);

        console.log(res.data);

        // Add the new review at the beginning of the array (no duplication)
        setReviews((prev) => [res.data, ...prev]);

        onClose(); // Close modal after successful submission
    } catch (error) {
        console.log(error, "some error occurred");
    }
};

    return isOpen ? (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white p-6 rounded-lg shadow-lg w-96 p-4">
          <h2 className="text-xl font-bold mb-4">Add Review</h2>

          {/* Rating (1-5 stars) */}
          <div className="mb-4">
            <label className="block font-medium">Rating:</label>
            <div className="flex space-x-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <span
                  key={star}
                  onClick={() => setRating(star)}
                  className={`cursor-pointer text-4xl ${
                    star <= rating ? 'text-yellow-500' : 'text-gray-400'
                  }`}
                >
                  {star <= rating ? '★' : '☆'}
                </span>
              ))}
            </div>
          </div>

          {/* Note Textarea */}
          <div className="mb-4">
            {/* <label className="block font-medium">Note:</label> */}
            <textarea
              className="w-full p-2 border rounded"
              rows="3"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Please write here..."
            ></textarea>
          </div>

          {/* Buttons */}
          <div className="flex justify-end space-x-2">
            <button
              className="px-4 py-2 bg-gray-400 text-white rounded bg-secondary p-2 m-2"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="px-4 py-2 bg-blue-500 text-white rounded "
              style={{ backgroundColor: '#1a54a6' }}
              onClick={handleReview}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    ) : null;
};

export default ReviewModal;
